import { render, staticRenderFns } from "./Staking.vue?vue&type=template&id=13db3f92&scoped=true&"
import script from "./Staking.vue?vue&type=script&lang=js&"
export * from "./Staking.vue?vue&type=script&lang=js&"
import style0 from "./Staking.vue?vue&type=style&index=0&id=13db3f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13db3f92",
  null
  
)

export default component.exports